module.exports = __webpack_public_path__ + "static/media/rectangle.587c094c.svg";